// Shared helpers for simulator widgets

export const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-PT', {
    style: 'currency',
    currency: 'EUR',
  }).format(value);
};

export const getScoreColorClass = (color) => {
  const colors = {
    "green": "bg-brand-500 text-white",
    "lime": "bg-lime text-primary",
    "yellow": "bg-yellow-500 text-white",
    "orange": "bg-orange-500 text-white",
    "red": "bg-red-500 text-white"
  };
  return colors[color] || "bg-gray-500 text-white";
};
